export default __webpack_public_path__ + "static/media/desk001.2ef874e1.jpeg";